import { Typography } from "@material-ui/core";
import { sanitizeFieldRestProps } from "react-admin";
import { useForm } from "react-final-form";

export const FormTextField = props => {
    const { className, source, emptyText, refresh, label, ...rest } = props;
    const form = useForm();
    const formData = form.getState().values;
    const value = formData[source];
    return (
        <>
            <div>{label}</div>
            <Typography
                component="span"
                variant="body2" ç
                style={{ fontSize: "1em" }}
                {...sanitizeFieldRestProps(rest)}
            >
                {value != null && typeof value !== 'string'
                    ? JSON.stringify(value)
                    : value || emptyText}
            </Typography>
        </>

    );
};